// extracted by mini-css-extract-plugin
export default {"container":"Grid_container__8zICX","lista":"Grid_lista__TvMUc"};